import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import * as dat from 'lil-gui'
import gsap from 'gsap'

/**
 * Base
 */
// Debug
const gui = new dat.GUI()

// Textures
const textureLoader = new THREE.TextureLoader()

const matcapTexture = textureLoader.load('./textures/matcaps/9.png')
const circleAlpha = textureLoader.load('./textures/matcaps/10.png')
const blurAlpha = textureLoader.load('./textures/blur-alpha.png')
const shadowAlpha = textureLoader.load('./textures/shadow-alpha.png')
const planeAlpha = textureLoader.load('./textures/plane-alpha.png')
const gridTexture = textureLoader.load('./textures/grid.jpg')
gridTexture.repeat.x = 30
gridTexture.repeat.y = 30
gridTexture.offset.x = 0.5
gridTexture.offset.y = 0.5
gridTexture.rotation = Math.PI / 4
gridTexture.wrapS = THREE.RepeatWrapping
gridTexture.wrapT = THREE.RepeatWrapping
gui.add(gridTexture.repeat, 'x').min(- 50).max(50).step(1).name('gridTextureRepeat x')
gui.add(gridTexture.repeat, 'y').min(- 50).max(50).step(1).name('gridTextureRepeat y')


// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Lights
 */
const ambientLight = new THREE.AmbientLight(0xffffff, 0.5)
// scene.add(ambientLight)

const light = new THREE.PointLight(0xffffff, 0.5)
light.position.x = 2
light.position.y = 3
light.position.z = 4
scene.add(light)

/**
 * Objects
 */

const cameraBlur = new THREE.PlaneGeometry( 2,2 )
const BlurMat = new THREE.MeshBasicMaterial( {color: 0x000000} )
const BlurSurface = new THREE.Mesh( cameraBlur, BlurMat )
console.log(blurAlpha);
BlurSurface.material.alphaMap = blurAlpha
BlurSurface.material.transparent = true
BlurSurface.position.x = -2
BlurSurface.position.y = 0
BlurSurface.position.z = 3
gui.add(BlurSurface.position, 'x').min(- 10).max(10).step(0.1).name('cameraBlur x')
gui.add(BlurSurface.position, 'y').min(- 10).max(10).step(0.1).name('cameraBlur y')
gui.add(BlurSurface.position, 'z').min(- 10).max(10).step(0.1).name('cameraBlur z')
scene.add(BlurSurface)

const ringMaterial = new THREE.MeshMatcapMaterial()
ringMaterial.matcap = matcapTexture

const torus = new THREE.TorusGeometry(1.2, 0.1, 64, 128)
const circleSurface = new THREE.CircleGeometry( 1.2, 32 )
const floor = new THREE.PlaneGeometry( 50, 20 )
const floorMat = new THREE.MeshBasicMaterial( {map: gridTexture} )
const floorSurface = new THREE.Mesh( floor, floorMat )
// floorSurface.material.alphaMap = planeAlpha
// floorSurface.material.transparent = true
floorSurface.rotation.x = - Math.PI / 2
floorSurface.position.y = -1.31
floorSurface.position.z = -2.5
gui.add(floorSurface.rotation, 'x').min(- 10).max(10).step(0.1).name('floorSurface x')
gui.add(floorSurface.position, 'y').min(- 10).max(10).step(0.1).name('floorSurface y')
gui.add(floorSurface.position, 'z').min(- 10).max(10).step(0.1).name('floorSurface z')
scene.add( floorSurface )

const video1 = document.getElementById( 'video1' )
video1.play()
const video2 = document.getElementById( 'video2' )
video2.play();
const video3 = document.getElementById( 'video3' )
video3.play();
const video4 = document.getElementById( 'video4' )
video4.play();


const ring1 = new THREE.Mesh(
    torus,
    ringMaterial
)
const ring2 = new THREE.Mesh(
    torus,
    ringMaterial
)
const ring3 = new THREE.Mesh(
    torus,
    ringMaterial
)
const ring4 = new THREE.Mesh(
    torus,
    ringMaterial
)
const OverlaySurface = new THREE.MeshBasicMaterial( { color: 0x4A93A5 } )

const ring1_content = new THREE.Mesh(
    circleSurface,
    new THREE.ShaderMaterial({
        uniforms: {
            tex: {
            value: new THREE.VideoTexture( video1 )
            }
        },
        vertexShader: `
            varying vec2 vUv;
            
            void main() {
            vUv = uv;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
            }
        `,
        fragmentShader: `
            varying vec2 vUv;
            uniform sampler2D tex;
            
            void main() {
                vec2 uv = vUv;
            float ratio = 1. / 1.; //480./204.;
            uv.y *= ratio;
            
            uv.y -= (0.5 - (1. / ratio) * 0.5) * ratio;
                    
            vec3 col = texture2D(tex, uv).rgb;
            
            col = mix(col, vec3(0), step(0.5, abs(uv.y - 0.5)));
            
            gl_FragColor = vec4(col, 1.);
            }
        `
    })    
)
ring1_content.material.opacity = 1
ring1_content.position.x = 0
ring1_content.position.z = -0.0001

const ring2_content = new THREE.Mesh(
    circleSurface,
    new THREE.ShaderMaterial({
        uniforms: {
            tex: {
            value: new THREE.VideoTexture( video2 )
            }
        },
        vertexShader: `
            varying vec2 vUv;
            
            void main() {
            vUv = uv;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
            }
        `,
        fragmentShader: `
            varying vec2 vUv;
            uniform sampler2D tex;
            
            void main() {
                vec2 uv = vUv;
            float ratio = 1. / 1.; //480./204.;
            uv.y *= ratio;
            
            uv.y -= (0.5 - (1. / ratio) * 0.5) * ratio;
                    
            vec3 col = texture2D(tex, uv).rgb;
            
            col = mix(col, vec3(0), step(0.5, abs(uv.y - 0.5)));
            
            gl_FragColor = vec4(col, 1.);
            }
        `
    })    
)
ring2_content.material.opacity = 1
ring2_content.position.x = 0
ring2_content.position.z = -0.0001

const ring3_content = new THREE.Mesh(
    circleSurface,
    new THREE.ShaderMaterial({
        uniforms: {
            tex: {
            value: new THREE.VideoTexture( video3 )
            }
        },
        vertexShader: `
            varying vec2 vUv;
            
            void main() {
            vUv = uv;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
            }
        `,
        fragmentShader: `
            varying vec2 vUv;
            uniform sampler2D tex;
            
            void main() {
                vec2 uv = vUv;
            float ratio = 1. / 1.; //480./204.;
            uv.y *= ratio;
            
            uv.y -= (0.5 - (1. / ratio) * 0.5) * ratio;
                    
            vec3 col = texture2D(tex, uv).rgb;
            
            col = mix(col, vec3(0), step(0.5, abs(uv.y - 0.5)));
            
            gl_FragColor = vec4(col, 1.);
            }
        `
    })    
)
ring3_content.material.opacity = 1
ring3_content.position.x = 0
ring3_content.position.z = -0.0001

const ring4_content = new THREE.Mesh(
    circleSurface,
    new THREE.ShaderMaterial({
        uniforms: {
            tex: {
            value: new THREE.VideoTexture( video4 )
            }
        },
        vertexShader: `
            varying vec2 vUv;
            
            void main() {
            vUv = uv;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
            }
        `,
        fragmentShader: `
            varying vec2 vUv;
            uniform sampler2D tex;
            
            void main() {
                vec2 uv = vUv;
            float ratio = 1. / 1.; //480./204.;
            uv.y *= ratio;
            
            uv.y -= (0.5 - (1. / ratio) * 0.5) * ratio;
                    
            vec3 col = texture2D(tex, uv).rgb;
            
            col = mix(col, vec3(0), step(0.5, abs(uv.y - 0.5)));
            
            gl_FragColor = vec4(col, 1.);
            }
        `
    })    
)
ring4_content.material.opacity = 1
ring4_content.position.x = 0
ring4_content.position.z = -0.0001


const ring1_cover = new THREE.Mesh( circleSurface, OverlaySurface )
ring1_cover.material.alphaMap = circleAlpha
ring1_cover.material.transparent = true
ring1_cover.position.x = 0
ring1_cover.position.z = 0

const ring2_cover = new THREE.Mesh( circleSurface, OverlaySurface )
ring2_cover.material.alphaMap = circleAlpha
ring2_cover.material.transparent = true
ring2_cover.position.x = 0
ring2_cover.position.z = 0

const ring3_cover = new THREE.Mesh( circleSurface, OverlaySurface )
ring3_cover.material.alphaMap = circleAlpha
ring3_cover.material.transparent = true
ring3_cover.position.x = 0
ring3_cover.position.z = 0

const ring4_cover = new THREE.Mesh( circleSurface, OverlaySurface )
ring4_cover.material.alphaMap = circleAlpha
ring4_cover.material.transparent = true
ring4_cover.position.x = 0
ring4_cover.position.z = 0

const shadowMat = new THREE.MeshBasicMaterial({color: 0x3ab09c, alphaMap: shadowAlpha, transparent: true})
const shadow1 = new THREE.Mesh(circleSurface,shadowMat)
shadow1.rotation.set(- Math.PI / 2, 0, 0)
shadow1.position.set(0,-1.27,0)
// shadow1.scale.set(3,0.75,0)

const shadow2 = new THREE.Mesh(circleSurface,shadowMat)
shadow2.rotation.set(- Math.PI / 2, 0, 0)
shadow2.position.set(0,-1.28,0)
// shadow2.scale.set(3,0.75,0)

const shadow3 = new THREE.Mesh(circleSurface,shadowMat)
shadow3.rotation.set(- Math.PI / 2, 0, 0)
shadow3.position.set(0,-1.29,0)
// shadow3.scale.set(3,0.75,0)

const shadow4 = new THREE.Mesh(circleSurface,shadowMat)
shadow4.rotation.set(- Math.PI / 2, 0, 0)
shadow4.position.set(0,-1.30,0)
// shadow4.scale.set(3,0.75,0)

// gui.add(shadow2.position, 'x').min(- 10).max(10).step(0.01).name('shadow2.position x')
// gui.add(shadow2.position, 'y').min(- 10).max(10).step(0.01).name('shadow2.position y')
// gui.add(shadow2.position, 'z').min(- 10).max(10).step(0.01).name('shadow2.position z')



// const slidePositionN3 = [-11.25,0,6]
// const slidePositionN2 = [-7.5,0,4]
// const slidePositionN1 = [-3.75,0,2]
// const slidePosition1 = [0,0,0]
// const slidePosition2 = [0.8,0,-0.5]
// const slidePosition3 = [1.6,0,-1]
// const slidePosition4 = [2.4,0,-1.5]

const slidePositionN3 = [-11.25,0,6]
const slidePositionN2 = [-7.5,0,4]
const slidePositionN1 = [-3.5,0,1.4]
const slidePosition1 = [0,0,0]
const slidePosition2 = [0.8,0,-0.5]
const slidePosition3 = [1.6,0,-1]
const slidePosition4 = [2.4,0,-1.5]

const slide1 = new THREE.Group()
const slide2 = new THREE.Group()
const slide3 = new THREE.Group()
const slide4 = new THREE.Group()
slide1.add( ring1_content, ring1, ring1_cover, shadow1)
slide2.add( ring2_content, ring2, ring2_cover, shadow2)
slide3.add( ring3_content, ring3, ring3_cover, shadow3)
slide4.add( ring4_content, ring4, ring4_cover, shadow4)
slide1.position.set(slidePosition1[0],slidePosition1[1],slidePosition1[2])
slide2.position.set(slidePosition2[0],slidePosition2[1],slidePosition2[2])
slide3.position.set(slidePosition3[0],slidePosition3[1],slidePosition3[2])
slide4.position.set(slidePosition4[0],slidePosition4[1],slidePosition4[2])
scene.add( slide1 , slide2, slide3, slide4)

document.querySelector('#slide1').addEventListener('click',()=>{
    gsap.to(slide1.position, { duration: 1, delay: 0, x: slidePosition1[0], z: slidePosition1[2] })
    gsap.to(slide2.position, { duration: 1, delay: 0, x: slidePosition2[0], z: slidePosition2[2] })
    gsap.to(slide3.position, { duration: 1, delay: 0, x: slidePosition3[0], z: slidePosition3[2] })
    gsap.to(slide4.position, { duration: 1, delay: 0, x: slidePosition4[0], z: slidePosition4[2] })
})

document.querySelector('#slide2').addEventListener('click',()=>{
    gsap.to(slide1.position, { duration: 1, delay: 0, x: slidePositionN1[0], z: slidePositionN1[2] })
    gsap.to(slide2.position, { duration: 1, delay: 0, x: slidePosition1[0], z: slidePosition1[2] })
    gsap.to(slide3.position, { duration: 1, delay: 0, x: slidePosition2[0], z: slidePosition2[2] })
    gsap.to(slide4.position, { duration: 1, delay: 0, x: slidePosition3[0], z: slidePosition3[2] })
})

document.querySelector('#slide3').addEventListener('click',()=>{
    gsap.to(slide1.position, { duration: 1, delay: 0, x: slidePositionN2[0], z: slidePositionN2[2] })
    gsap.to(slide2.position, { duration: 1, delay: 0, x: slidePositionN1[0], z: slidePositionN1[2] })
    gsap.to(slide3.position, { duration: 1, delay: 0, x: slidePosition1[0], z: slidePosition1[2] })
    gsap.to(slide4.position, { duration: 1, delay: 0, x: slidePosition2[0], z: slidePosition2[2] })
})

document.querySelector('#slide4').addEventListener('click',()=>{
    gsap.to(slide1.position, { duration: 1, delay: 0, x: slidePositionN3[0], z: slidePositionN3[2] })
    gsap.to(slide2.position, { duration: 1, delay: 0, x: slidePositionN2[0], z: slidePositionN2[2] })
    gsap.to(slide3.position, { duration: 1, delay: 0, x: slidePositionN1[0], z: slidePositionN1[2] })
    gsap.to(slide4.position, { duration: 1, delay: 0, x: slidePosition1[0], z: slidePosition1[2] })
})


gui.add(slide1.position, 'x').min(- 10).max(10).step(0.01).name('slide1 x')
gui.add(slide1.position, 'z').min(- 10).max(10).step(0.01).name('slide1 z')
gui.add(slide1.position, 'x').min(- 10).max(10).step(0.01).name('slide1 x')
gui.add(slide1.position, 'z').min(- 10).max(10).step(0.01).name('slide1 z')
gui.add(slide2.position, 'x').min(- 10).max(10).step(0.01).name('slide2 x')
gui.add(slide2.position, 'z').min(- 10).max(10).step(0.01).name('slide2 z')
gui.add(slide3.position, 'x').min(- 10).max(10).step(0.01).name('slide3 x')
gui.add(slide3.position, 'z').min(- 10).max(10).step(0.01).name('slide3 z')
gui.add(slide4.position, 'x').min(- 10).max(10).step(0.01).name('slide4 x')
gui.add(slide4.position, 'z').min(- 10).max(10).step(0.01).name('slide4 z')

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(55, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 0
camera.position.y = 0
camera.position.z = 4
gui.add(camera.position, 'x').min(- 10).max(10).step(0.1).name('camera x')
gui.add(camera.position, 'y').min(- 10).max(10).step(0.1).name('camera y')
gui.add(camera.position, 'z').min(- 10).max(10).step(0.1).name('camera z')
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()